export const certificates = [
  {
    id: 1,
    title: "IT Essentials: PC Hardware and Software",
    imageUrl: "assets/images/IT_Essentials_certificate_cisco.jpeg",
    certificateImageUrl: "assets/images/IT_Essentials_certificate_cisco.jpeg",
    description: `
      <p>This course from Cisco Networking Academy provided comprehensive training in PC hardware and software fundamentals. It covered computer hardware components, assembly, operating systems, networking basics, and troubleshooting techniques.</p>
      <p><strong>Categories:</strong> IT Fundamentals, Hardware, Software, Networking, Troubleshooting</p>
      <p><strong>Provider:</strong> Cisco Networking Academy</p>
      <p>Completion Date: 2018</p>
    `,
    link: ""
  },
  {
    id: 2,
    title: "Web Design for Everybody: Basics of Web Development & Coding",
    imageUrl: "assets/images/michigan-coursera.webp",
    certificateImageUrl: "assets/images/web_design_cert.webp",
    description: `
      <p>This comprehensive course from the University of Michigan laid a strong foundation in web development. It covered HTML5, CSS3, and JavaScript, emphasizing the creation of responsive web pages that are both visually appealing and accessible across different devices.</p>
      <p><strong>Categories:</strong> Web Development, HTML, CSS, Responsive Design</p>
      <p><strong>Provider:</strong> University of Michigan on Coursera</p>
      <p>Completion Date: July 22, 2020</p>
    `,
    link: "https://www.coursera.org/account/accomplishments/specialization/58FLXCNPS3CP"
  },
  {
    id: 3,
    title: "Python for Everybody",
    imageUrl: "assets/images/michigan-coursera.webp",
    certificateImageUrl: "assets/images/python_cert.webp",
    description: `
      <p>This in-depth specialization from the University of Michigan introduced Python programming from basic syntax to complex data structures and networked application program interfaces. The course culminated in a hands-on project involving data retrieval, processing, and visualization.</p>
      <p><strong>Categories:</strong> Python Programming, Data Structures, Algorithms, Web Scraping</p>
      <p><strong>Provider:</strong> University of Michigan on Coursera</p>
      <p>Completion Date: Sep 10, 2020</p>
    `,
    link: "https://www.coursera.org/account/accomplishments/specialization/GN3JH7YYQLDV"
  },
  {
    id: 4,
    title: "Web Applications for Everybody",
    imageUrl: "assets/images/michigan-coursera.webp",
    certificateImageUrl: "assets/images/web_app_cert.webp",
    description: `
      <p>The Web Applications for Everybody specialization provided a detailed exploration of modern web development. It covered essential technologies such as HTML, CSS, JavaScript, and PHP, allowing me to build dynamic and responsive web applications from scratch.</p>
      <p><strong>Categories:</strong> Web Development, HTML, CSS, JavaScript, PHP, Web Architecture</p>
      <p><strong>Provider:</strong> University of Michigan on Coursera</p>
      <p>Completion Date: Dec 12, 2020</p>
    `,
    link: "https://www.coursera.org/account/accomplishments/specialization/S3TP6W7VW3EB"
  },
  {
    id: 5,
    title: "Data Analysis and Visualization Foundations",
    imageUrl: "assets/images/ibm.webp",
    certificateImageUrl: "assets/images/data_analysis_cert.webp",
    description: `
      <p>This program from IBM provided a robust foundation in data analysis techniques, including statistical analysis, data visualization, and exploratory data analysis. I developed proficiency in tools such as Python, R, and Tableau for making data-driven decisions.</p>
      <p><strong>Provider:</strong> IBM on Coursera</p>
      <p>Completion Date: April 12, 2021</p>
    `,
    link: "https://www.coursera.org/account/accomplishments/specialization/DKC787F5D4EW"
  },
  {
    id: 6,
    title: "Django for Everybody Specialization",
    imageUrl: "assets/images/michigan-coursera.webp",
    certificateImageUrl: "assets/images/django_cert.webp",
    description: `
      <p>This Coursera and University of Michigan specialization focused on building websites using the Django library. It covered HTML, CSS, SQL, Django, JavaScript, jQuery, and JSON web services. I practiced my skills by building online websites and receiving feedback throughout the program.</p>
      <p><strong>Categories:</strong> Web Development, Django (Web Framework), Computer Programming, Other Web Frameworks, Javascript, SQL, Data Model, Python Programming</p>
      <p><strong>Provider:</strong> University of Michigan on Coursera</p>
      <p>Completion Date: June 7, 2021</p>
    `,
    link: "https://www.coursera.org/account/accomplishments/specialization/9YHCDKAARJTK"
  },
  {
    id: 7,
    title: "Full-Stack Web Development with React Specialization",
    imageUrl: "assets/images/full_stack.webp",
    certificateImageUrl: "assets/images/react_cert.webp",
    description: `
      <p>This specialization from The Hong Kong University of Science and Technology offered comprehensive training in full-stack web development. It covered front-end frameworks like React, back-end development with Node.js, and databases using MongoDB, focusing on building and deploying full-stack applications.</p>
      <p><strong>Categories:</strong> Front-End Web Development, Web Development, React, Mobile Development, JavaScript, Server-Side Development</p>
      <p><strong>Provider:</strong> The Hong Kong University of Science and Technology on Coursera</p>
      <p>Completion Date: October 9, 2021</p>
    `,
    link: "https://www.coursera.org/account/accomplishments/specialization/QYMZYWG3AWN6"
  },
  {
    id: 8,
    title: "Google Data Analytics Professional Certificate",
    imageUrl: "assets/images/google.webp",
    certificateImageUrl: "assets/images/googleda_cert.webp",
    description: `
      <p>The Google Data Analytics Professional Certificate program provided an in-depth understanding of the data analysis process. It emphasized hands-on learning using tools like SQL, R, spreadsheets, and Tableau to clean, analyze, and visualize data for business insights.</p>
      <p><strong>Categories:</strong> Data Analysis, SQL, R Programming, Spreadsheet Software, Data Visualization, Business Analysis</p>
      <p><strong>Provider:</strong> Google on Coursera</p>
      <p>Completion Date: February 8, 2022</p>
    `,
    link: "https://www.coursera.org/account/accomplishments/professional-cert/YLCB4E6WLL6F"
  },
  {
    id: 9,
    title: "IBM Data Analyst Professional Certificate",
    imageUrl: "assets/images/ibm.webp",
    certificateImageUrl: "assets/images/ibmda_cert.webp",
    description: `
      <p>This IBM professional certificate equipped me with vital data analysis skills. The coursework covered tools and techniques such as Excel, SQL, Python, and Cognos Analytics, enabling me to analyze data, create visualizations, and build interactive dashboards.</p>
      <p><strong>Categories:</strong> Data Analysis, Data Visualization, SQL, Python Programming, Business Analysis</p>
      <p><strong>Provider:</strong> IBM on Coursera</p>
      <p>Completion Date: July 2, 2022</p>
    `,
    link: "https://www.coursera.org/account/accomplishments/professional-cert/Z86ZWX7W5K3N"
  },
  {
    id: 10,
    title: "Introduction to Data Science Specialization",
    imageUrl: "assets/images/ibm.webp",
    certificateImageUrl: "assets/images/ids_cert.webp",
    description: `
      <p>This specialization from IBM provided a robust foundation in data science, covering key concepts and techniques in R and Python programming, data modeling, and data analysis. It prepared me for more advanced studies and practical applications in the field.</p>
      <p><strong>Categories:</strong> Data Science, R Programming, Python Programming, Data Modeling, Data Analysis, Machine Learning</p>
      <p><strong>Provider:</strong> IBM on Coursera</p>
      <p>Completion Date: April 29, 2024</p>
    `,
    link: "https://www.coursera.org/account/accomplishments/specialization/62YAA3JTN5VA"
  },
  {
    id: 11,
    title: "IBM Data Science Professional Certificate",
    imageUrl: "assets/images/ibm.webp",
    certificateImageUrl: "assets/images/ibmds_cert.webp",
    description: `
      <p>The IBM Data Science Professional Certificate offered an in-depth exploration of data science principles. It covered a broad range of topics from Python programming and data analysis to machine learning and data visualization, providing hands-on experience in solving real-world data problems.</p>
      <p><strong>Categories:</strong> Data Science, Python Programming, Machine Learning, Data Visualization, Deep Learning, Human-Computer Interaction</p>
      <p><strong>Provider:</strong> IBM on Coursera</p>
      <p>Completion Date: April 29, 2024</p>
    `,
    link: "https://www.coursera.org/account/accomplishments/specialization/certificate/IBMDataScience"
  },
  {
    id: 12,
    title: "Applied Data Science with Python Specialization",
    imageUrl: "assets/images/michigan-coursera.webp",
    certificateImageUrl: "assets/images/ads_cert.webp",
    description: `
      <p>This University of Michigan specialization focused on applying data science techniques using Python. It covered essential topics such as data analysis, machine learning, and data visualization, emphasizing practical, hands-on experience to solve real-world data science problems.</p>
      <p><strong>Categories:</strong> Data Science, Python Programming, Data Analysis, Machine Learning, Algorithms</p>
      <p><strong>Provider:</strong> University of Michigan on Coursera</p>
      <p>Completion Date: May 20, 2024</p>
    `,
    link: "https://www.coursera.org/account/accomplishments/specialization/S3TP6W7VW3EA"
  },
  {
    id: 13,
    title: "Natural Language Processing Specialization",
    imageUrl: "assets/images/nlp-specialization.webp",
    certificateImageUrl: "assets/images/nlp_cert.webp",
    description: `
      <p>Offered by DeepLearning.AI, this specialization covered a comprehensive range of topics in Natural Language Processing (NLP). I gained proficiency in sentiment analysis, text generation, named entity recognition, machine translation, and chatbot development through hands-on projects and real-world applications.</p>
      <p><strong>Categories:</strong> Natural Language Processing, Sentiment Analysis, Text Generation, Named Entity Recognition, Machine Translation, Chatbot Development</p>
      <p><strong>Provider:</strong> DeepLearning.AI on Coursera</p>
      <p>Completion Date: July 10, 2024</p>
    `,
    link: "https://www.coursera.org/account/accomplishments/specialization/WYXP5LNB8J6H"
  }
];
